import { normalizeURL } from '@philips-internal/oswald-common-utils';
import { isContentfulString } from '@philips-internal/oswald-ui-utils';
function findRouteById(routes, id) {
    if (!isContentfulString(id)) {
        return;
    }
    for (const current of routes) {
        if (current.id === id) {
            return current;
        }
        if (Array.isArray(current.children)) {
            const foundRoute = findRouteById(current.children, id);
            if (foundRoute) {
                return foundRoute;
            }
        }
    }
    return;
}
async function getRoutes() {
    // @ts-expect-error
    const { get } = await import('virtual:oswald-routes');
    const content = await get();
    const routes = [];
    if (Array.isArray(content)) {
        for (const route of content) {
            routes.push(structuredClone(route));
        }
    }
    return routes;
}
function normalizeRoutes(routes, basePath = '') {
    for (const route of routes) {
        const newPath = `${basePath}/${route.path}`;
        route.path = normalizeURL(newPath);
        if (Array.isArray(route.children)) {
            normalizeRoutes(route.children, newPath);
        }
    }
}
export { findRouteById, getRoutes, normalizeRoutes, };
//# sourceMappingURL=routes.js.map